import { inject, Injectable } from '@angular/core';
import { Transition } from 'angular-ui-router';
import { FilterModel } from 'ag-grid-community';
import { $state } from 'app/ajs-upgraded-providers';
import { StockMovementType } from '../models/stock-movements.model';

export interface StockMovementsFiltersState {
  date_from: Date | null;
  date_to: Date | null;
  stock_location_id: number | null;
  movement_type: StockMovementType | null;
}

export interface StockMovementsSavedState {
  // filtri della topbar (date, magazzino, tipo movimento)
  filters?: StockMovementsFiltersState;
  // testo della search bar in alto
  searchText?: string;
  // filtri di colonna della griglia master (batch) e della lista di ricerca: le colonne sono diverse
  batchesFilterModel?: FilterModel | null;
  searchFilterModel?: FilterModel | null;
}

// stati del modulo magazzino: lo stato si mantiene navigando tra questi
const STOCK_MODULE_STATE_PREFIX = 'app.new.stock';

/**
 * Stato della pagina dei movimenti, mantenuto navigando all'interno del modulo magazzino.
 * Vive in root (il componente viene distrutto a ogni navigazione) e si azzera uscendo dal modulo.
 */
@Injectable({ providedIn: 'root'})
export class StockMovementsStateService {

  private readonly state = inject($state);

  private savedState: StockMovementsSavedState = {};

  constructor() {
    this.state.router.transitionService.onSuccess({}, (transition: Transition) => {
      if (!transition.to().name?.startsWith(STOCK_MODULE_STATE_PREFIX)) {
        this.clearState();
      }
    });
  }

  getState(): StockMovementsSavedState {
    return this.savedState;
  }

  updateState(partialState: Partial<StockMovementsSavedState>) {
    this.savedState = { ...this.savedState, ...partialState };
  }

  clearState() {
    this.savedState = {};
  }
}
